import { render, staticRenderFns } from "./SuperSuppliersModal.vue?vue&type=template&id=f48fa388"
import script from "./SuperSuppliersModal.vue?vue&type=script&lang=js"
export * from "./SuperSuppliersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports